function ConfiguratorSchalldaemmwand(){
    var configurator = null;

    $fieldsetSchallleistung = $(".js-fieldset_schallleistung");
    $fieldsetSchallleistungGesamtwertLw = $(".js-fieldset_schallleistung_gesamtwert_lw");
    $fieldsetSchallleistungGesamtwertLp = $(".js-fieldset_schallleistung_gesamtwert_lp");
    $fieldsetOktavwerte = $(".js-fieldset_oktavwerte");

    $schallleistungspegel = $(".js-schallleistungspegel");
    $schallleistungGesamtwertLw = $(".js-schallleistung_gesamtwert_lw");
    $schallleistungGesamtwertLp = $(".js-schallleistung_gesamtwert_lp");
    $schallleistungPegelAbstand = $(".js-schallleistung_pegel_abstand");
    $oktawerte = $(".js-oktawerte");

    $fieldset_beschaffung = $(".js-fieldset_beschaffung");
    $bodenbeschaffung = $(".js-bodenbeschaffung");

    $fieldset_schallquelle = $(".js-fieldset_schallquelle");
    $schallquelle_entf_schalldaemmwand = $(".js-schallquelle_entf_schalldaemmwand");
    $schallquelle_entf_boden = $(".js-schallquelle_entf_boden");
    $schallquelle_wandnaehe = $(".js-schallquelle_wandnaehe");

    $fieldset_empfaenger = $(".js-fieldset_empfaenger");
    $empfaenger_entf_schalldaemmwand = $(".js-empfaenger_entf_schalldaemmwand");
    $empfaenger_entf_boden = $(".js-empfaenger_entf_boden");
    $empfaenger_wandnaehe = $(".js-empfaenger_wandnaehe");

    $fieldset_wand_abmessung = $(".js-fieldset_wand_abmessung");
    $wand_abmessung_hoehe = $(".js-wand_abmessung_hoehe");
    $wand_abmessung_laenge = $(".js-wand_abmessung_laenge");

    this.setConfigurator = function(configurator){
        this.configurator = configurator;
    }

    this.showStep2 = function(){
        showSchallleistungspegel();
        validStep2();
    }

    validStep2 = function(){
        var valid = true;

        if(valid && !validSchallleistung()) valid = false;
        if(valid && !validOktavwerte()) valid = false;

        this.configurator.allowNextExt(valid && validOktavwerteCount() > 0);

        return valid;
    }

    this.showStep3 = function() {
        showBeschaffung();
        validStep3();
    }

    validStep3 = function() {
        var valid = true;

        if(valid && !validateBeschaffung()) valid = false;
        if(valid && !validateSchallquelle()) valid = false;
        if(valid && !validateEmpfaenger()) valid = false;
        if(valid && !validateAbmessung()) valid = false;

        this.configurator.allowNextExt(valid);

        return valid;
    }

    this.fillErgData = function (){

        if($(".js-schallleistungspegel:checked").val() == "lw"){
            $(".js-erg-schallleistungspegel_typ").text($fieldsetSchallleistung.data("lw"));
            $(".js-erg-schallleistung_gesamtwert").text($schallleistungGesamtwertLw.val());
            $(".js-erg-schallleistung_abstand-block").hide();
        }else if($(".js-schallleistungspegel:checked").val() == "lp"){
            $(".js-erg-schallleistungspegel_typ").text($fieldsetSchallleistung.data("lp"));
            $(".js-erg-schallleistung_gesamtwert").text($schallleistungGesamtwertLp.val());
            $(".js-erg-schallleistung_abstand").text($schallleistungPegelAbstand.val());
            $(".js-erg-schallleistung_abstand-block").show();
        }

        $oktawerte.each(function(key, element){
            var $currentElement = $(element);
            if(key == 0){
                var wert = $currentElement.val();
                $(".js-erg-db31_5").text(wert);
            } else if(key == 1){
                var wert = $currentElement.val();
                $(".js-erg-db63").text(wert);
            } else if(key == 2){
                var wert = $currentElement.val();
                $(".js-erg-db125").text(wert);
            } else if(key == 3){
                var wert = $currentElement.val();
                $(".js-erg-db250").text(wert);
            } else if(key == 4){
                var wert = $currentElement.val();
                $(".js-erg-db500").text(wert);
            } else if(key == 5){
                var wert = $currentElement.val();
                $(".js-erg-db1000").text(wert);
            } else if(key == 6){
                var wert = $currentElement.val();
                $(".js-erg-db2000").text(wert);
            } else if(key == 7){
                var wert = $currentElement.val();
                $(".js-erg-db40000").text(wert);
            } else if(key == 8){
                var wert = $currentElement.val();
                $(".js-erg-db80000").text(wert);
            } else if(key == 9){
                var wert = $currentElement.val();
                $(".js-erg-db160000").text(wert);
            }
        });


        $(".js-erg-bodenbeschaffung").text($fieldset_beschaffung.find(":checked").data("title"));
        $(".js-erg-schallquelle_entf_schalldaemmwand").text($schallquelle_entf_schalldaemmwand.val());
        $(".js-erg-schallquelle_entf_boden").text($schallquelle_entf_boden.val());
        $(".js-erg-schallquelle_wandnaehe").text($fieldset_schallquelle.find(":checked").data("title"));
        $(".js-erg-empfaenger_entf_schalldaemmwand").text($empfaenger_entf_schalldaemmwand.val());
        $(".js-erg-empfaenger_entf_boden").text($empfaenger_entf_boden.val());
        $(".js-erg-empfaenger_wandnaehe").text($fieldset_empfaenger.find(":checked").data("title"));
        $(".js-erg-wand_abmessung_hoehe").text($wand_abmessung_hoehe.val());
        $(".js-erg-wand_abmessung_haenge").text($wand_abmessung_laenge.val());
    }

    $schallleistungspegel.on("change", function(){
        $oktawerte.val("");
        validStep2();
    });

    $schallleistungGesamtwertLw.on("keyup", function(){
        validStep2();
    });

    $schallleistungGesamtwertLp.on("keyup", function(){
        validStep2();
    });

    $schallleistungPegelAbstand.on("keyup", function(){
        validStep2();
    });

    $oktawerte.on("keyup", function(){
        validStep2();
    });

    validSchallleistung = function(){
        var valid = true;

        if($(".js-schallleistungspegel:checked").val() == "lp"){
            showSchallleistungGesamtwertLp();
            clearFieldValidaitonClass($schallleistungGesamtwertLp);
            clearFieldValidaitonClass($schallleistungPegelAbstand);
            $schallleistungGesamtwertLw.val("");
            valid = ($schallleistungGesamtwertLp.val() != "" && $schallleistungPegelAbstand.val() != "");

            if($schallleistungGesamtwertLp.val() != "" && !validFloatNumberInput($schallleistungGesamtwertLp.val(), 30.0, 100.0)){
                valid = false;
                setFieldValidaitonClass($schallleistungGesamtwertLp, valid);
            }

            if($schallleistungPegelAbstand.val() != "" && !validIntNumberInput($schallleistungPegelAbstand.val(), 1, 50)){
                valid = false;
                setFieldValidaitonClass($schallleistungPegelAbstand, valid);
            }

            if(valid){
                setFieldValidaitonClass($schallleistungGesamtwertLp, valid);
            }
        }else if($(".js-schallleistungspegel:checked").val() == "lw"){
            showSchallleistungGesamtwertLw();

            clearFieldValidaitonClass($schallleistungGesamtwertLw);
            $schallleistungGesamtwertLp.val("");
            $schallleistungPegelAbstand.val(1);
            valid = ($schallleistungGesamtwertLw.val() != "");
            if($schallleistungGesamtwertLw.val() != "" && !validFloatNumberInput($schallleistungGesamtwertLw.val(), 30.0, 120.0)){
                valid = false;
                setFieldValidaitonClass($schallleistungGesamtwertLw, valid);

            }
            if(valid){
                setFieldValidaitonClass($schallleistungGesamtwertLw, valid);
            }
        }else{
            valid = false;
        }

        if(valid){
            showOktavwerte();
        }

        return valid;
    }


    validOktavwerte = function(){
        var valid = true;

        var validValueCount = 0;

        clearFieldValidaitonClass($oktawerte);
        $.each($oktawerte, function(key, element){
            $currentElement = $(element);

            if($currentElement.val() != "" && !validFloatNumberInput($currentElement.val(), 15.0, 120.0)){
                valid = false;
                setFieldValidaitonClass($currentElement, valid);
            }

            if($currentElement.val() != "" && valid){
                validValueCount++;
            }
        });

        if(validValueCount > 0 && validValueCount < 7){
            valid = false;
            setFieldValidaitonClass($currentElement, valid);
        }

        return valid;
    }

    validOktavwerteCount = function(){
        var validValueCount = 0;
        var valid = true;

        $.each($oktawerte, function(key, element){
            $currentElement = $(element);

            if($currentElement.val() != "" && !validFloatNumberInput($currentElement.val(), 15.0, 120.0)){
                valid = false;
            }

            if($currentElement.val() != "" && valid){
                validValueCount++;
            }
        });

        return validValueCount;
    }

    showSchallleistungspegel = function(){
        $fieldsetSchallleistung.show();
        $fieldsetSchallleistungGesamtwertLw.hide();
        $fieldsetSchallleistungGesamtwertLp.hide();
        $fieldsetOktavwerte.hide();
    }

    showSchallleistungGesamtwertLw = function(){
        $fieldsetSchallleistung.show();
        $fieldsetSchallleistungGesamtwertLw.show();
        $fieldsetSchallleistungGesamtwertLp.hide();
        $fieldsetOktavwerte.hide();
    }

    showSchallleistungGesamtwertLp = function(){
        $fieldsetSchallleistung.show();
        $fieldsetSchallleistungGesamtwertLw.hide();
        $fieldsetSchallleistungGesamtwertLp.show();
        $fieldsetOktavwerte.hide();
    }

    showOktavwerte = function(){
        $fieldsetSchallleistung.show();
        if($(".js-schallleistungspegel:checked").val() == "lp"){
            $fieldsetSchallleistungGesamtwertLw.hide();
            $fieldsetSchallleistungGesamtwertLp.show();
        }else{
            $fieldsetSchallleistungGesamtwertLw.show();
            $fieldsetSchallleistungGesamtwertLp.hide();
        }
        $fieldsetOktavwerte.show();
    }

    $bodenbeschaffung.on("change", function(){
        validStep3();
    });

    $schallquelle_entf_schalldaemmwand.on("keyup", function(){
        validStep3();
    });

    $schallquelle_entf_boden.on("keyup", function(){
        validStep3();
    });

    $schallquelle_wandnaehe.on("change", function(){
        validStep3();
    });

    $empfaenger_entf_schalldaemmwand.on("keyup", function(){
        validStep3();
    });

    $empfaenger_entf_boden.on("keyup", function(){
        validStep3();
    });

    $empfaenger_wandnaehe.on("change", function(){
        validStep3();
    });

    $wand_abmessung_hoehe.on("keyup", function(){
        validStep3();
    });

    $wand_abmessung_laenge.on("keyup", function(){
        validStep3();
    });


    $(document).on("click", ".js-modal_desc-click", function(){
        $element = $(this);
        $(".js-modal_desc-headline").text($element.data("headline"));
        $(".js-modal_desc-text").text($element.data("text"));
        $(".js-modal_desc-link").attr("href", $element.data("link"));
    });

    function showBeschaffung(){
        $fieldset_beschaffung.show();
        $fieldset_schallquelle.hide();
        $fieldset_empfaenger.hide();
        $fieldset_wand_abmessung.hide();
    }

    function showSchallquelle(){
        $fieldset_schallquelle.show();
        $fieldset_empfaenger.hide();
        $fieldset_wand_abmessung.hide();
    }

    function showEmpfaenger(){
        $fieldset_empfaenger.show();
        $fieldset_wand_abmessung.hide();
    }

    function showAbmessung(){
        $fieldset_wand_abmessung.show();
    }

    function validateBeschaffung(){
        valid = $fieldset_beschaffung.find(":checked").length == 1;

        if(valid){
            showSchallquelle();
        }

        return valid;
    }

    function validateSchallquelle(){
        valid = true;

        clearFieldValidaitonClass($schallquelle_entf_schalldaemmwand);
        clearFieldValidaitonClass($schallquelle_entf_boden);

        valid = ($schallquelle_entf_schalldaemmwand.val() != "" && $schallquelle_entf_boden.val() != "");

        if($schallquelle_entf_schalldaemmwand.val() != "" && !validFloatNumberInput($schallquelle_entf_schalldaemmwand.val(), 0.01, 100.00, 2)){
            valid = false;
            setFieldValidaitonClass($schallquelle_entf_schalldaemmwand, valid);
        }

        if($schallquelle_entf_boden.val() != "" && !validFloatNumberInput($schallquelle_entf_boden.val(), 0.01, 20.00, 2)){
            valid = false;
            setFieldValidaitonClass($schallquelle_entf_boden, valid);
        }

        // js-schallquelle_wandnaehe
        if($fieldset_schallquelle.find(":checked").length != 1){
            valid = false;
        };

        if(valid){
            showEmpfaenger();
        }

        return valid;
    }

    function validateEmpfaenger(){
        valid = true;

        clearFieldValidaitonClass($empfaenger_entf_schalldaemmwand);
        clearFieldValidaitonClass($empfaenger_entf_boden);

        valid = ($empfaenger_entf_schalldaemmwand.val() != "" && $empfaenger_entf_boden.val() != "");

        if($empfaenger_entf_schalldaemmwand.val() != "" && !validFloatNumberInput($empfaenger_entf_schalldaemmwand.val(), 0.01, 100.00, 2)){
            valid = false;
            setFieldValidaitonClass($empfaenger_entf_schalldaemmwand, valid);
        }

        if($empfaenger_entf_boden.val() != "" && !validFloatNumberInput($empfaenger_entf_boden.val(), 0.01, 20, 2)){
            valid = false;
            setFieldValidaitonClass($empfaenger_entf_boden, valid);
        }

        // js-empfaenger_wandnaehe
        if($fieldset_empfaenger.find(":checked").length != 1){
            valid = false;
        };

        if(valid){
            showAbmessung();
        }

        return valid;
    }

    function validateAbmessung(){
        valid = true;

        clearFieldValidaitonClass($wand_abmessung_hoehe);
        clearFieldValidaitonClass($wand_abmessung_laenge);

        valid = ($wand_abmessung_hoehe.val() != "" && $wand_abmessung_laenge.val() != "");

        if($wand_abmessung_hoehe.val() != "" && !validFloatNumberInput($wand_abmessung_hoehe.val(), 0.50, 4.80, 2)){
            valid = false;
            setFieldValidaitonClass($wand_abmessung_hoehe, valid);
        }

        if($wand_abmessung_laenge.val() != "" && !validFloatNumberInput($wand_abmessung_laenge.val(), 0.50, 100, 2)){
            valid = false;
            setFieldValidaitonClass($wand_abmessung_laenge, valid);
        }

        return valid;
    }
}